export default "__VITE_ASSET__wbuCK_u2__"